import { render, staticRenderFns } from "./StationSlide.vue?vue&type=template&id=3c2e92a8&scoped=true"
import script from "./StationSlide.vue?vue&type=script&lang=js"
export * from "./StationSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e92a8",
  null
  
)

export default component.exports